import Sidebars from "../../components/sidebars/Sidebars";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";

import React, { useEffect, useState } from "react";
import {
  getCheckoutSettings,
  saveCheckoutSettings
} from "../../Services/CheckoutSettingsApi";


function OrderSettingsLayout({ children }) {
  return (
    <>
      <Sidebars />
      <Header />
      <main id="main" className="main mt-0 h-100 min-vh-80">
        {children}
      </main>
      <Footer />
    </>
  );
}

export default function OrderSettings() {
  const [settings, setSettings] = useState({
    activeMethod: "telegram",
    telegramUsername: "",
    smsPhone: "+19295041178"
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const [chatMode, setChatMode] =
    useState("telegram");

  const [uiSettings, setUiSettings] =
    useState({});


  useEffect(() => {
    let active = true;

    getCheckoutSettings()
      .then((data) => {
        if (active) setSettings(data);
      })
      .catch((err) => {
        if (active) setError(err.message);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  
  /* GALAXY_CHAT_SETTINGS_LOAD_V2 */
  useEffect(() => {
    let active = true;

    const loadChatSettings = async () => {
      try {
        const token =
          localStorage.getItem("tokenAdmin");

        const response = await fetch(
          "https://api.galaxylabsnyc.com/api/v1/Admin/ui-settings",
          {
            method: "GET",
            headers: {
              authorization:
                "Bearer " + token
            },
            cache: "no-store"
          }
        );

        const result =
          await response.json();

        if (!response.ok) {
          throw new Error(
            result?.message ||
            "Unable to load chat settings."
          );
        }

        const payload =
          result?.data?.data ??
          result?.data ??
          result ??
          {};

        if (!active) return;

        setUiSettings(payload);

        setChatMode(
          payload?.chatMode === "phone"
            ? "phone"
            : "telegram"
        );

      } catch (err) {
        console.error(
          "Customer chat settings load:",
          err
        );
      }
    };

    loadChatSettings();

    return () => {
      active = false;
    };
  }, []);

const change = (field, value) => {
    setSettings((previous) => ({
      ...previous,
      [field]: value
    }));
    setMessage("");
  };

  const save = async (event) => {
    event.preventDefault();

    setSaving(true);
    setMessage("");
    setError("");

    try {
      const telegramUsername =
        String(
          settings.telegramUsername || ""
        )
          .trim()
          .replace(
            /^https?:\/\/(?:www\.)?t\.me\//i,
            ""
          )
          .replace(/^@+/, "")
          .replace(/\s+/g, "");

      const smsPhone =
        String(
          settings.smsPhone || ""
        )
          .trim()
          .replace(/[^0-9+]/g, "");

      const cleanSettings = {
        ...settings,
        telegramUsername,
        smsPhone
      };

      /*
        Save checkout choice:
        Telegram or SMS/iMessage.
      */
      const checkoutResult =
        await saveCheckoutSettings(
          cleanSettings
        );

      const savedCheckout =
        checkoutResult?.data?.data ??
        checkoutResult?.data ??
        checkoutResult ??
        {};

      setSettings({
        ...cleanSettings,
        ...(savedCheckout &&
           typeof savedCheckout === "object"
          ? savedCheckout
          : {})
      });

      /*
        Save purple CHAT button separately.
      */
      const chatValue =
        chatMode === "phone"
          ? smsPhone
          : telegramUsername;

      if (!chatValue) {
        throw new Error(
          chatMode === "phone"
            ? "Enter the phone number used for the chat button."
            : "Enter the Telegram username used for the chat button."
        );
      }

      const token =
        localStorage.getItem(
          "tokenAdmin"
        );

      const chatResponse =
        await fetch(
          "https://api.galaxylabsnyc.com/api/v1/Admin/ui-settings",
          {
            method: "PUT",

            headers: {
              "Content-Type":
                "application/json",

              authorization:
                "Bearer " + token
            },

            body: JSON.stringify({
              ...uiSettings,
              chatMode,
              chatValue
            })
          }
        );

      const chatResult =
        await chatResponse.json();

      if (
        !chatResponse.ok ||
        chatResult?.success === false ||
        chatResult?.status === false
      ) {
        throw new Error(
          chatResult?.message ||
          "Unable to save Customer Chat settings."
        );
      }

      const savedUi =
        chatResult?.data?.data ??
        chatResult?.data ??
        chatResult ??
        {};

      setUiSettings({
        ...uiSettings,
        ...(savedUi &&
           typeof savedUi === "object"
          ? savedUi
          : {}),
        chatMode,
        chatValue
      });

      setMessage(
        "Order settings saved successfully."
      );

    } catch (err) {
      console.error(
        "Order Settings save:",
        err
      );

      setError(
        err?.message ||
        "Unable to save Order Settings."
      );

    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <OrderSettingsLayout><div className="container py-4">Loading order settings...</div></OrderSettingsLayout>;
  }

  return (
    <OrderSettingsLayout>
      <div className="container py-4">
      <h2>Order Settings</h2>
      <p>Control how customers send their orders.</p>

      {error && <div className="alert alert-danger">{error}</div>}
      {message && <div className="alert alert-success">{message}</div>}

      <form onSubmit={save}>
        <div className="mb-4">
          <h5>Active Checkout Method</h5>

          <label className="d-block mb-2">
            <input
              type="radio"
              name="checkoutMethod"
              checked={settings.activeMethod === "telegram"}
              onChange={() => change("activeMethod", "telegram")}
            />
            {" "}Telegram
          </label>

          <label className="d-block">
            <input
              type="radio"
              name="checkoutMethod"
              checked={settings.activeMethod === "sms"}
              onChange={() => change("activeMethod", "sms")}
            />
            {" "}SMS / iMessage
          </label>
        </div>

        <div className="mb-3">
          <label className="form-label">Telegram Username</label>
          <input
            className="form-control"
            type="text"
            placeholder="@username"
            value={settings.telegramUsername || ""}
            onChange={(e) => change("telegramUsername", e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">SMS Receiving Number</label>
          <input
            className="form-control"
            type="tel"
            placeholder="+19295041178"
            value={settings.smsPhone || ""}
            onChange={(e) => change("smsPhone", e.target.value)}
          />
        </div>

        
      <hr className="my-4" />

      <div className="mb-4">
        <h5>Customer Chat Button</h5>

        <p className="text-muted mb-2">
          Controls the purple chat button next to the shopping cart.
          This is separate from the checkout method above.
        </p>

        <label className="d-block mb-2">
          <input
            type="radio"
            name="customerChatMethod"
            checked={
              chatMode === "telegram"
            }
            onChange={() =>
              setChatMode("telegram")
            }
          />
          {" "}Telegram
        </label>

        <label className="d-block mb-2">
          <input
            type="radio"
            name="customerChatMethod"
            checked={
              chatMode === "phone"
            }
            onChange={() =>
              setChatMode("phone")
            }
          />
          {" "}Phone Number / SMS
        </label>

        <small className="text-muted">
          Telegram uses the Telegram Username above.
          Phone uses the SMS Receiving Number above.
        </small>
      </div>

<button
          className="btn btn-primary"
          type="submit"
          disabled={saving}
        >
          {saving ? "Saving..." : "Save Changes"}
        </button>
      </form>
      </div>
    </OrderSettingsLayout>
  );
}
